'use strict';
var $spinnerFnProxy = $.fn.spinner;
var $spinnerProxy = $.spinner;

require('jquery-ui/dist/jquery-ui.js');

$.fn.spinner = $spinnerFnProxy;
$.spinner = $spinnerProxy;
